/* eslint-disable no-redeclare */
import { z } from 'zod';

export const HealthcareUserId = z
  .string()
  .length(32)
  .regex(/^[0-9A-F]{32}$/, 'Invalid Healthcare user id');

export type HealthcareUserId = z.infer<typeof HealthcareUserId>;
